import { useState, useEffect } from 'react';
import useIntersectionObserver from '@stencil/use-intersection-observer';

const useListLazyLoading = (displayFlightList = []) => {
  const initialList = displayFlightList.slice(0, 10);

  const [currentDisplayList = [], setCurrentDisplayList] = useState(initialList);

  useEffect(() => {
    setCurrentDisplayList(initialList);
  }, [displayFlightList]);

  let currentDisplayNumber = initialList.length;
  let [canAddMore, setAddMore] = useState(initialList.length < displayFlightList.length);

  const addItemsToList = () => {
    setCurrentDisplayList(currList => {
      const newItems = displayFlightList.slice(currentDisplayNumber, currentDisplayNumber + 10);
      currentDisplayNumber = currentDisplayNumber + 10;
      if (currentDisplayNumber >= displayFlightList.length) {
        setAddMore(false);
      }
      return [...currList, ...newItems];
    });
  };

  const intersectionObserverOptions = {
    root: null,
    threshHold: 0.01
  };

  let [loaderRef] = useIntersectionObserver(intersectionObserverOptions, () => {
    addItemsToList();
  });

  return { loaderRef, currentDisplayList, canAddMore };
};

export default useListLazyLoading;
